// Supabase Auth returns English error messages. Map the ones users can hit
// on the sign-in and password screens to translation keys.

type LocalizedAuthError = {
  key: string;
  args?: Record<string, string>;
};

const RULES: { pattern: RegExp; key: string; arg?: string }[] = [
  {
    pattern: /Password should contain at least one character of each/i,
    key: "crm.auth.errors.password_requirements",
  },
  {
    pattern: /Password should be at least (\d+) characters/i,
    key: "crm.auth.errors.password_too_short",
    arg: "min",
  },
  {
    pattern: /should be different from the old password/i,
    key: "crm.auth.errors.same_password",
  },
  {
    pattern: /Invalid login credentials/i,
    key: "crm.auth.errors.invalid_credentials",
  },
  {
    pattern: /Email not confirmed/i,
    key: "crm.auth.errors.email_not_confirmed",
  },
  {
    pattern: /expired|invalid.*(token|link)|otp/i,
    key: "crm.auth.errors.link_expired",
  },
  {
    pattern: /rate limit|too many requests|security purposes/i,
    key: "crm.auth.errors.rate_limited",
  },
];

export const localizeAuthError = (
  error: unknown,
): LocalizedAuthError | null => {
  const message =
    typeof error === "string"
      ? error
      : error instanceof Error
        ? error.message
        : typeof error === "object" && error && "message" in error
          ? String((error as { message: unknown }).message)
          : "";
  for (const rule of RULES) {
    const match = message.match(rule.pattern);
    if (match) {
      return {
        key: rule.key,
        args: rule.arg && match[1] ? { [rule.arg]: match[1] } : undefined,
      };
    }
  }
  return null;
};
